import React, { ChangeEvent, HTMLInputTypeAttribute } from 'react'

function InputField({
  className,
  id,
  type = 'text',
  name,
  placeholder,
  label,
  defaultValue,
  onChange,
  onBlur,
  error,
}: {
  className: string
  id: string
  type?: HTMLInputTypeAttribute
  name: string
  placeholder: string
  label: string
  defaultValue: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  onBlur: (e: ChangeEvent<HTMLInputElement>) => void
  error: string
}) {
  return (
    <div className="first:mt-0 desktop:mt-8 tablet:mt-8 sp:mt-8">
      <label
        htmlFor={id}
        className="block text-left font-bold font-yu-gothic text-text-black"
      >
        {label}
      </label>
      <div className="desktop:mt-3 tablet:mt-3 sp:mt-3">
        <input
          required
          className={className}
          type={type}
          id={id}
          name={name}
          placeholder={placeholder}
          defaultValue={defaultValue}
          onChange={onChange}
          onBlur={onBlur}
          aria-describedby={`${id}_error`}
        />
        {error && (
          <span
            id={`${id}_error`}
            className="block text-left font-yu-gothic text-xs text-notify-red desktop:mt-4 tablet:mt-4 sp:mt-4"
          >
            {error}
          </span>
        )}
      </div>
    </div>
  )
}

export default InputField
